export {
  isWebKit,
  isMac,
  isIPhone,
  isIPad,
  isIOS,
  isAppleDevice,
  isChrome,
  isAndroid,
  isFirefox,
  isSafari
} from '../../../src/utils/platform';
